module.exports = __webpack_public_path__ + "img/nhat-ki-he-thong-icon.cc37b99b.svg";